/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import { useSelector } from 'react-redux'
import { RootReducer } from 'src/redux/rootReducer'

const useDealerAllowedToPlaceOffer = (): boolean => {
  const dealerAllowedToPlaceOffer = useSelector((state: RootReducer) => {
    return !state.userDataReducer.test_access && !state.userDataReducer.blocked
  })
  return dealerAllowedToPlaceOffer
}

export default useDealerAllowedToPlaceOffer
